export function drawAllTitles(titleImgs, shuffledIds, board, ctx) {
  for (let index = 0; index < shuffledIds.length; index++) {
    if (shuffledIds[index] == -1) {
      let coord = getRowColFromIndex(index, board.rowCols);
      let x = coord.x;
      let y = coord.y;
      ctx.save();
      ctx.fillStyle = "#808080";
      ctx.fillRect(
        x * board.titleWidth,
        y * board.titleHeight,
        board.titleWidth,
        board.titleHeight
      );
      ctx.restore();
    }

    let coord = getRowColFromIndex(index, board.rowCols);
    let x = coord.x;
    let y = coord.y;
    let imgURL = titleImgs[shuffledIds[index]];
    let imgObj = new Image();
    imgObj.onload = function () {
      ctx.drawImage(
        this,
        0,
        0,
        this.width,
        this.height,
        x * board.titleWidth,
        y * board.titleHeight,
        board.titleWidth,
        board.titleHeight
      );
    };
    imgObj.src = imgURL;
  }
}
export function getRowColFromIndex(index, board) {
  let col = Math.floor(index / board);
  let row = index % board;
  return { x: row, y: col };
}
